import { outter_post } from 'common/js/axios-helper';
import { MallApi } from "./constant/UrlMapper";



const host = '8880';
const host2 = '9000';

const memIntegralInfo = (data) => {
    return outter_post(MallApi.MemIntegralInfo, data, host);
};

const tatIntegralCardSetting = (data) => {
    return outter_post(MallApi.TatIntegralCardSetting, data, host);
};

const changeExpiredDate = (data) => {
    return outter_post(MallApi.ChangeExpiredDate, data, host);
};

const tatGoodsAdd = (data) => {
    return outter_post(MallApi.TatGoodsAdd, data, host2);
};

const tatGoodsDel = (data) => {
    return outter_post(MallApi.TatGoodsDel, data, host2);
};

const tatGoodsEdit = (data) => {
    return outter_post(MallApi.TatGoodsEdit, data, host2);
};

const tatGoodsList = (data) => {
    return outter_post(MallApi.TatGoodsList, data, host2);
};

const tatGoodsUdpStatus = (data) => {
    return outter_post(MallApi.TatGoodsUdpStatus, data, host2);
};

const publicplatoongoodsList = (data) => {
    return outter_post(MallApi.PublicPlatoonGoodsList, data, host2);
};

const publicplatoongoodsAdd = (data) => {
    return outter_post(MallApi.PublicPlatoonGoodsAdd, data, host2);
};

const publicplatoongoodsEdit = (data) => {
    return outter_post(MallApi.PublicPlatoonGoodsEdit, data, host2);
};

const publicplatoongoodsDel = (data) => {
    return outter_post(MallApi.PublicPlatoonGoodsDel, data, host2);
};

const publicplatoongoodsUdpStatus = (data) => {
    return outter_post(MallApi.PublicPlatoonGoodsUdpStatus, data, host2);
};

const storeGoodsListAll = (data) => {
    return outter_post(MallApi.StoreGoodsListAll, data, host2);
};

const getBusinessType = (data) => {
    return outter_post(MallApi.GetBusinessType, data, host2);
};

const smsList = (data) => {
    return outter_post(MallApi.SmsList, data, host);
};
const smsEdit = (data) => {
    return outter_post(MallApi.SmsEdit, data, host);
};
const smsInsert = (data) => {
    return outter_post(MallApi.SmsInsert, data, host);
};
const smsDelete = (data) => {
    return outter_post(MallApi.SmsDelete, data, host);
};
const smsTypes = (data) => {
    return outter_post(MallApi.SmsTypes, data, host);
};

// 厦门银行
const withdrawalreviewList = (data) => {
    return outter_post(MallApi.WithdrawalReviewList, data, "8885");
};
const withdrawalreviewCheck = (data) => {
    return outter_post(MallApi.WithdrawalReviewCheck, data, "8885");
};

// 通联
const connectwithdrawalreviewList = (data) => {
    return outter_post(MallApi.ConnectWithdrawalReviewList, data, "8885");
};
const connectwithdrawalreviewCheck = (data) => {
    return outter_post(MallApi.ConnectWithdrawalReviewCheck, data, "8885");
};

// 线下缴费审核
const offlinepaymentreviewList = (data) => {
    return outter_post(MallApi.OfflinePaymentReviewList, data, "8883");
};
const offlinepaymentreviewToExamine = (data) => {
    return outter_post(MallApi.OfflinePaymentReviewToExamine, data, "8883");
};

const summoney = (data) => {
    return outter_post(MallApi.SumMoney, data, "8885");
};
const tdmoney = (data) => {
    return outter_post(MallApi.TdMoney, data, "8885");
};

// 线下二维码
const offlineQRcodeList = (data) => {
    return outter_post(MallApi.OfflineQRCodeList, data, "8883");
};
const offlineQRcodeEdit = (data) => {
    return outter_post(MallApi.OfflineQRCodeEdit, data, "8883");
};
const offlineQRcodeInsert = (data) => {
    return outter_post(MallApi.OfflineQRCodeInsert, data, "8883");
};
const offlineQRcodeDel = (data) => {
    return outter_post(MallApi.OfflineQRCodeDel, data, "8883");
};
const offlineQRcodeStatus = (data) => {
    return outter_post(MallApi.OfflineQRCodeStatus, data, "8883");
};

//代理商分润合计
const agentsharehj = (data) => {
    return outter_post(MallApi.AgentshareHj, data, "8885");
};

// 钱包管理

export default {
    memIntegralInfo,
    tatIntegralCardSetting,
    changeExpiredDate,
    smsList,
    smsEdit,
    smsInsert,
    smsDelete,
    smsTypes,
    tatGoodsAdd,
    tatGoodsDel,
    tatGoodsEdit,
    tatGoodsList,
    tatGoodsUdpStatus,

    publicplatoongoodsAdd,
    publicplatoongoodsDel,
    publicplatoongoodsEdit,
    publicplatoongoodsList,
    publicplatoongoodsUdpStatus,

    storeGoodsListAll,
    getBusinessType,

    withdrawalreviewList,
    withdrawalreviewCheck,

    connectwithdrawalreviewList,
    connectwithdrawalreviewCheck,

    offlinepaymentreviewList,
    offlinepaymentreviewToExamine,

    offlineQRcodeList,
    offlineQRcodeEdit,
    offlineQRcodeInsert,
    offlineQRcodeDel,
    offlineQRcodeStatus,

    summoney,
    tdmoney,

    agentsharehj,
}



// WEBPACK FOOTER //
// ./src/service/MallService.js